import { type Command } from '@telespot/core';

/**
 * Details for {@link AddMemberships}
 *
 * @group Workspaces
 * @category Payloads
 */
export interface AddMembershipsDetails {
  /**
   * Identifier of the user to add the memberships to.
   */
  userId: string;

  /**
   * Identifiers of the workspaces to add the memberships to.
   */
  workspaceIds: string[];

  /**
   * The batch size for the addition.
   * Indicates the number of memberships to add in parallel.
   */
  batchSize: number;
}

/**
 * Errors for {@link AddMemberships}
 *
 * @group Workspaces
 * @category Errors
 */
export type AddMembershipsError = { type: 'UNKNOWN'; message: string };

/**
 * Command registration token for {@link AddMemberships}
 *
 * @group Workspaces
 * @category Tokens
 */
export const ADD_MEMBERSHIPS = 'workspaces:addMemberships';

/**
 * Adds memberships to a user.
 *
 * @group Workspaces
 * @category Commands
 */
export class AddMemberships implements Command<typeof ADD_MEMBERSHIPS, AddMembershipsDetails> {
  public readonly name = ADD_MEMBERSHIPS;
  constructor(public readonly details: Readonly<AddMembershipsDetails>) {}
}
